module.exports = __webpack_public_path__ + "img/lang-white.66f68f58.svg";